"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

function AnkiIcon({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn("size-4", className)}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polygon
        points="20.3 18.1 24 24.3 31.3 23.9 26.5 29.3 29.4 36.1 22.8 33 17.2 37.9 17.8 30.6 11.7 26.9 18.8 25.3 20.3 18.1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon
        points="34.4 9.7 34 13.2 36.7 14.9 33.6 15.4 32.6 18.6 31 15.8 27.7 15.9 29.9 13.5 28.8 10.4 31.9 11.9 34.4 9.7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="24"
        cy="24"
        r="21.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChatGPTIcon({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn("size-4", className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5967_5364)">
        <path
          d="M14.8163 6.55655C15.1765 5.47601 15.0529 4.29333 14.4777 3.30955C13.6122 1.8043 11.8704 1.03017 10.1716 1.39036C9.79675 0.970274 9.3369 0.634653 8.82253 0.405738C8.30816 0.176822 7.75101 0.0598408 7.188 0.0625459C5.45163 0.0625459 3.90875 1.1807 3.37116 2.83108C2.253 3.06223 1.29072 3.76108 0.726251 4.75026C-0.144624 6.25548 0.0542821 8.14777 1.22081 9.43798C0.860657 10.5185 0.984282 11.7012 1.5595 12.6796C2.425 14.1903 4.16678 14.9644 5.87094 14.6042C6.62356 15.4535 7.70947 15.9428 8.84916 15.9374C10.5855 15.9374 12.1284 14.8192 12.666 13.1688C13.7842 12.9377 14.7464 12.2388 15.3055 11.2497C16.1818 9.74442 15.9829 7.85211 14.8163 6.56192V6.55655ZM13.5799 3.83098C13.9239 4.43308 14.053 5.13733 13.9347 5.82005C13.9132 5.80392 13.8702 5.78242 13.8433 5.7663L10.6823 3.93848C10.6028 3.89355 10.5129 3.86994 10.4216 3.86994C10.3302 3.86994 10.2404 3.89355 10.1608 3.93848L6.45691 6.07811V4.50836L9.51575 2.7397C10.9403 1.9172 12.7574 2.40639 13.5799 3.83098ZM6.45691 7.09411L8.01591 6.19098L9.57488 7.09411V8.89505L8.01591 9.79817L6.45691 8.89505V7.09411ZM7.18263 1.10005C7.8815 1.10005 8.55347 1.34198 9.09106 1.78817C9.06956 1.79892 9.02656 1.8258 8.99428 1.84192L5.83331 3.66436C5.67203 3.75576 5.57525 3.9278 5.57525 4.11592V8.39511L4.21516 7.61023V4.07289C4.21516 2.42789 5.543 1.10008 7.188 1.0947L7.18263 1.10005ZM1.62938 5.27176C1.97881 4.66964 2.52178 4.20733 3.17763 3.96542V7.72311C3.17763 7.91123 3.27441 8.07792 3.43569 8.17467L7.13425 10.3089L5.76878 11.0991L2.71531 9.33586C1.29609 8.51336 0.806876 6.69633 1.62938 5.27173V5.27176ZM2.46266 12.169C2.11322 11.5722 1.98956 10.8626 2.10784 10.1799C2.12934 10.196 2.17234 10.2175 2.19922 10.2336L5.36022 12.0615C5.43977 12.1064 5.52959 12.13 5.62095 12.13C5.71232 12.13 5.80214 12.1064 5.88169 12.0615L9.58025 9.92186V11.4916L6.52141 13.2549C5.09681 14.072 3.27978 13.5882 2.45728 12.169H2.46266ZM8.85453 14.8999C8.16103 14.8999 7.48369 14.658 6.95147 14.2118C6.98423 14.1948 7.01651 14.1768 7.04825 14.158L10.2093 12.3356C10.3705 12.2442 10.4727 12.0722 10.4673 11.884V7.6102L11.8274 8.39508V11.927C11.8274 13.572 10.4942 14.9052 8.85453 14.9052V14.8999V14.8999ZM14.4131 10.7282C14.0637 11.3303 13.5153 11.7926 12.8649 12.0291V8.27145C12.8649 8.0833 12.7681 7.91126 12.6068 7.81989L8.90291 5.6803L10.263 4.89542L13.3218 6.65867C14.7464 7.48117 15.2303 9.29823 14.4078 10.7228L14.4132 10.7282H14.4131Z"
          fill="#71717A"
        />
      </g>
      <defs>
        <clipPath id="clip0_5967_5364">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function BlackGoogleIcon({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn("size-4", className)}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5967_5387)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.01816 11.5854C0.472692 10.5091 0.159973 9.29453 0.159973 8C0.159973 6.70544 0.472692 5.49091 1.01816 4.41453C2.3345 1.79638 5.03269 0 8.15997 0C10.32 0 12.1236 0.792719 13.5127 2.08728L11.2218 4.37819C10.3854 3.59272 9.33813 3.18544 8.15997 3.18544C6.07997 3.18544 4.31269 4.58909 3.67997 6.48C3.51997 6.96 3.42541 7.46906 3.42541 8C3.42541 8.53091 3.51997 9.04 3.67997 9.52L3.6705 9.52725H3.67997C4.31269 11.4182 6.07997 12.8218 8.15997 12.8218C9.23632 12.8218 10.1454 12.5309 10.8581 12.0509C11.7091 11.4836 12.2763 10.64 12.4654 9.64363H8.15997V6.54544H15.6945C15.789 7.06909 15.8399 7.61453 15.8399 8.18181C15.8399 10.6182 14.9672 12.6691 13.4545 14.0654C12.1309 15.2872 10.32 16 8.15997 16C5.03269 16 2.3345 14.2036 1.01816 11.5927V11.5854Z"
          fill="#71717A"
        />
      </g>
      <defs>
        <clipPath id="clip0_5967_5387">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function TikTokIcon({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn("size-4", className)}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5967_5380)">
        <path
          d="M11.4316 0.0491718H8.87332V10.9186C8.87332 12.343 7.85004 13.2593 6.60556 13.2593C5.36105 13.2593 4.25483 12.343 4.25483 10.9186C4.25483 9.27284 5.54099 8.40388 7.25563 8.58379V5.82953C7.00674 5.78789 6.75785 5.77423 6.55026 5.77423C3.74305 5.77423 1.39197 8.02833 1.39197 10.8216C1.39197 13.7811 3.71505 16.0488 6.56391 16.0488C9.06694 16.0488 11.7222 14.2096 11.7222 10.7386V5.08252C12.8284 6.18875 14.1699 6.53462 15.608 6.53462V3.98995C13.838 3.86532 11.8741 2.70379 11.4316 0.0488281V0.0491718Z"
          fill="#71717A"
        />
      </g>
      <defs>
        <clipPath id="clip0_5967_5380">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function RedditIcon({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn("size-4", className)}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.17423 7.99999C5.71288 7.99999 5.33987 8.373 5.33987 8.83435C5.33987 9.2957 5.71288 9.6687 6.17423 9.6687C6.63558 9.6687 7.00858 9.2957 7.00858 8.83435C7.00858 8.373 6.63558 7.99999 6.17423 7.99999Z"
        fill="#71717A"
      />
      <path
        d="M7.99999 11.6417C8.32392 11.6417 9.41349 11.6024 9.98282 11.0331C10.0712 10.9546 10.0712 10.8172 9.973 10.719C9.89447 10.6307 9.75705 10.6307 9.66871 10.719C9.30552 11.0822 8.53006 11.2098 7.99018 11.2098C7.4503 11.2098 6.68466 11.092 6.32147 10.7288C6.24294 10.6405 6.10552 10.6405 6.01717 10.7288C5.92883 10.8074 5.92883 10.9448 6.01717 11.0331C6.5865 11.6024 7.67607 11.6417 7.99999 11.6417Z"
        fill="#71717A"
      />
      <path
        d="M9.00122 8.83435C9.00122 9.2957 9.37423 9.6687 9.83558 9.6687C10.2969 9.6687 10.6699 9.2957 10.6699 8.83435C10.6699 8.373 10.2969 7.99999 9.83558 7.99999C9.37423 7.99999 9.00122 8.373 9.00122 8.83435Z"
        fill="#71717A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.1718 6.83189C12.8196 6.83189 13.3399 7.35214 13.3399 7.99999C13.3399 8.48097 13.0552 8.88343 12.6528 9.0503C12.6724 9.16809 12.6822 9.28588 12.6822 9.40367C12.6822 11.2 10.5914 12.6528 8.00981 12.6528C5.42822 12.6528 3.33742 11.2 3.33742 9.40367C3.33742 9.28588 3.34723 9.16809 3.36687 9.0503C2.96441 8.87361 2.67975 8.46134 2.67975 7.99017C2.67975 7.34232 3.19999 6.82208 3.84785 6.82208C4.16196 6.82208 4.44662 6.94968 4.65275 7.146C5.46748 6.55704 6.57668 6.19385 7.82331 6.15459L8.41226 3.36686C8.42208 3.31778 8.45153 3.2687 8.50061 3.23925C8.54969 3.20981 8.60858 3.19999 8.65766 3.20981L10.6012 3.62208C10.7386 3.34723 11.0233 3.16073 11.3472 3.16073C11.8086 3.16073 12.1816 3.53373 12.1816 3.99508C12.1816 4.45643 11.8086 4.82944 11.3472 4.82944C10.8957 4.82944 10.5325 4.47606 10.5129 4.03435L8.77545 3.66134L8.24539 6.16441C9.47239 6.20367 10.5718 6.57668 11.3669 7.15582C11.573 6.9595 11.8577 6.83189 12.1718 6.83189Z"
        fill="#71717A"
      />
    </svg>
  );
}

function FileUploadImage({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      viewBox="0 0 200 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        display: "block",
        width: "100%",
        height: "100%",
      }}
      preserveAspectRatio="xMaxYMax meet"
    >
      <g clipPath="url(#clip0_3054_1990)">
        <mask id="path-1-inside-1_3054_1990" fill="white">
          <path d="M0 8C0 3.58172 3.58172 0 8 0H200V112C200 116.418 196.418 120 192 120H0V8Z" />
        </mask>
        <rect width="200" height="40" fill="white" />
        <path
          d="M24.4221 19.3883C24.4221 21.7565 22.5024 23.6762 20.1343 23.6762C17.7661 23.6762 15.8464 21.7565 15.8464 19.3883C15.8464 17.0202 17.7661 15.1005 20.1343 15.1005C22.5024 15.1005 24.4221 17.0202 24.4221 19.3883Z"
          fill="#EAEAEA"
          stroke="#ECECF1"
          strokeWidth="0.372857"
        />
        <path
          d="M39.3364 19.3883C39.3364 21.7565 37.4167 23.6762 35.0486 23.6762C32.6804 23.6762 30.7607 21.7565 30.7607 19.3883C30.7607 17.0202 32.6804 15.1005 35.0486 15.1005C37.4167 15.1005 39.3364 17.0202 39.3364 19.3883Z"
          fill="#EAEAEA"
          stroke="#ECECF1"
          strokeWidth="0.372857"
        />
        <path
          d="M54.2507 19.3883C54.2507 21.7565 52.331 23.6762 49.9629 23.6762C47.5948 23.6762 45.675 21.7565 45.675 19.3883C45.675 17.0202 47.5948 15.1005 49.9629 15.1005C52.331 15.1005 54.2507 17.0202 54.2507 19.3883Z"
          fill="#EAEAEA"
          stroke="#ECECF1"
          strokeWidth="0.372857"
        />
        <path d="M0 40H200V119.829H0V40Z" fill="white" />

        <path
          d="M66.5994 69.6236H76.6815C77.0315 69.6236 77.3153 69.3399 77.3153 68.9898V56.8123C77.3153 56.4622 77.0315 56.1785 76.6815 56.1785H66.5994C66.2494 56.1785 65.9656 56.4622 65.9656 56.8123V68.9898C65.9656 69.3399 66.2494 69.6236 66.5994 69.6236Z"
          fill="#185ABD"
        />
        <path
          d="M76.6815 56.1994H66.5995C66.5169 56.1984 66.435 56.2139 66.3586 56.245C66.2821 56.2762 66.2127 56.3223 66.1543 56.3806C66.0959 56.439 66.0498 56.5085 66.0187 56.5849C65.9876 56.6614 65.9721 56.7433 65.9731 56.8258V59.5551H77.3154V56.8183C77.3154 56.7358 77.2989 56.6541 77.2669 56.578C77.2348 56.5019 77.1879 56.433 77.1289 56.3753C77.0698 56.3177 76.9998 56.2724 76.923 56.2422C76.8461 56.2119 76.7641 56.1974 76.6815 56.1994Z"
          fill="#41A5EE"
        />
        <path
          d="M77.3153 62.9121H65.973V66.2753H77.3153V62.9121Z"
          fill="#185ABD"
        />
        <path
          d="M77.3153 59.5488H65.973V62.912H77.3153V59.5488Z"
          fill="#2B7CD3"
        />

        <path
          d="M69.5375 59.1309H63.2437C62.8937 59.1309 62.6099 59.4146 62.6099 59.7647V66.0585C62.6099 66.4086 62.8937 66.6924 63.2437 66.6924H69.5375C69.8876 66.6924 70.1714 66.4086 70.1714 66.0585V59.7647C70.1714 59.4146 69.8876 59.1309 69.5375 59.1309Z"
          fill="#185ABD"
        />
        <path
          d="M65.1975 63.9624L65.9059 60.8603H66.7635L67.5167 63.6567C67.56 63.8306 67.5899 64.0076 67.6062 64.1861C67.6062 64.037 67.6435 63.8655 67.6807 63.6716L68.2251 60.8379H69.0081L68.0461 64.9393H67.1438L66.4876 62.2249L65.6971 64.9617H64.7352L63.7657 60.8603H64.5562L65.1528 63.7313C65.1719 63.8074 65.1869 63.8846 65.1975 63.9624Z"
          fill="white"
        />

        <path
          d="M100.425 56.1934H100.417C96.7068 56.1934 93.6986 59.2015 93.6986 62.9122V62.9197C93.6986 66.6304 96.7068 69.6386 100.417 69.6386H100.425C104.136 69.6386 107.144 66.6304 107.144 62.9197V62.9122C107.144 59.2015 104.136 56.1934 100.425 56.1934Z"
          fill="#D35230"
        />
        <path
          d="M100.417 56.2012C98.6375 56.2012 96.9304 56.9083 95.6718 58.1669C94.4131 59.4255 93.7061 61.1326 93.7061 62.9126H100.417V56.2012Z"
          fill="#ED6C47"
        />
        <path
          d="M100.417 56.2012C102.197 56.2012 103.905 56.9083 105.163 58.1669C106.422 59.4255 107.129 61.1326 107.129 62.9126H100.417V56.2012Z"
          fill="#FF8F6B"
        />

        <g clipPath="url(#clip1_3054_1990)">
          <path
            d="M125.447 56.9485C125.447 56.2792 125.99 55.7367 126.659 55.7367H131.467L135.888 60.2585V68.9656C135.888 69.6349 135.346 70.1774 134.676 70.1774H126.659C125.99 70.1774 125.447 69.6349 125.447 68.9656V56.9485Z"
            fill="white"
            stroke="#C8D2E1"
            strokeWidth="0.559286"
          />
          <path
            d="M131.506 55.8301V59.1858C131.506 59.8036 132.007 60.3044 132.625 60.3044H135.981"
            stroke="#C8D2E1"
            strokeWidth="0.559286"
            strokeLinecap="round"
          />
        </g>
        <rect
          x="123.304"
          y="60.1523"
          width="9.86429"
          height="6.49143"
          rx="0.745714"
          fill="#FF1607"
        />
        <path
          d="M124.892 64.8984V62.1867H125.962C126.168 62.1867 126.343 62.226 126.488 62.3046C126.632 62.3823 126.743 62.4904 126.819 62.629C126.895 62.7667 126.934 62.9256 126.934 63.1057C126.934 63.2857 126.895 63.4446 126.817 63.5823C126.74 63.72 126.627 63.8273 126.48 63.9041C126.333 63.9809 126.156 64.0193 125.947 64.0193H125.265V63.5598H125.855C125.965 63.5598 126.056 63.5408 126.127 63.5029C126.2 63.464 126.254 63.4106 126.289 63.3427C126.325 63.2738 126.343 63.1948 126.343 63.1057C126.343 63.0156 126.325 62.9371 126.289 62.87C126.254 62.802 126.2 62.7495 126.127 62.7124C126.055 62.6744 125.963 62.6555 125.852 62.6555H125.465V64.8984H124.892Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3054_1990">
          <path d="M0 8C0 3.58172 3.58172 0 8 0H200V112C200 116.418 196.418 120 192 120H0V8Z" />
        </clipPath>
        <clipPath id="clip1_3054_1990">
          <rect
            width="11.1857"
            height="14.9143"
            fill="white"
            transform="translate(125.168 55.457)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function IconGoogle({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Google">
        <g id="super-g">
          <path
            id="Shape"
            d="M8.49901 3.21522C9.96367 3.21522 10.9517 3.84789 11.515 4.37655L13.7163 2.22722C12.3643 0.970552 10.605 0.199219 8.49901 0.199219C5.44834 0.199219 2.81367 1.94989 1.53101 4.49789L4.05301 6.45655C4.68567 4.57589 6.43634 3.21522 8.49901 3.21522Z"
            fill="#EA4335"
          />
          <path
            id="Shape_2"
            d="M15.9873 8.17279C15.9873 7.53146 15.9353 7.06346 15.8226 6.57812H8.49927V9.47279H12.7979C12.7113 10.1921 12.2433 11.2755 11.2033 12.0035L13.6646 13.9101C15.1379 12.5495 15.9873 10.5475 15.9873 8.17279Z"
            fill="#4285F4"
          />
          <path
            id="Shape_3"
            d="M4.06164 9.54205C3.89697 9.05671 3.80164 8.53671 3.80164 7.99938C3.80164 7.46205 3.89697 6.94205 4.05297 6.45671L1.53097 4.49805C1.00231 5.55538 0.698975 6.74271 0.698975 7.99938C0.698975 9.25605 1.00231 10.4434 1.53097 11.5007L4.06164 9.54205Z"
            fill="#FBBC05"
          />
          <path
            id="Shape_4"
            d="M8.49913 15.7983C10.6051 15.7983 12.3731 15.105 13.6645 13.909L11.2031 12.0023C10.5445 12.4617 9.66046 12.7823 8.49913 12.7823C6.43646 12.7823 4.68579 11.4217 4.06179 9.54102L1.53979 11.4997C2.82246 14.0477 5.44846 15.7983 8.49913 15.7983Z"
            fill="#34A853"
          />
        </g>
      </g>
    </svg>
  );
}

function IconQuizlet({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn("size-4", className)}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3079_6000)">
        <path
          d="M9.52285 0.954337C8.29606 0.874271 7.06747 1.08053 5.93409 1.55682C4.80071 2.03311 3.79358 2.76638 2.99226 3.69874C2.18645 4.63196 1.60707 5.73869 1.29929 6.93264C0.991511 8.12659 0.963647 9.37549 1.21787 10.582C1.4721 11.7885 2.00154 12.9199 2.76493 13.8882C3.52831 14.8564 4.50501 15.6352 5.61887 16.164C6.72941 16.6895 7.94703 16.9493 9.17535 16.9229C10.4037 16.8964 11.609 16.5844 12.6959 16.0116C12.7306 15.9938 12.7694 15.9855 12.8084 15.9877C12.8474 15.9897 12.8851 16.0022 12.9176 16.0238C13.9498 16.7151 15.1674 17.0771 16.4096 17.0619C16.4388 17.0619 16.4678 17.0562 16.4949 17.045C16.5219 17.0338 16.5465 17.0173 16.5671 16.9966C16.5878 16.9759 16.6042 16.9513 16.6153 16.9242C16.6265 16.8971 16.6322 16.8681 16.6321 16.8388V14.126C16.6328 14.0729 16.6146 14.0213 16.5808 13.9803C16.5471 13.9393 16.4998 13.9118 16.4475 13.9029C16.1919 13.8624 15.9423 13.7904 15.7043 13.6888C15.6748 13.6757 15.6485 13.6563 15.6273 13.632C15.6061 13.6077 15.5905 13.579 15.5816 13.548C15.5727 13.517 15.5704 13.4844 15.5749 13.4524C15.5796 13.4205 15.591 13.3899 15.6084 13.3628C16.7815 11.5999 17.209 9.44425 16.7975 7.36705C16.386 5.28986 15.169 3.46003 13.4123 2.27752C12.2526 1.49886 10.9076 1.04071 9.51373 0.949537L9.52285 0.954337ZM4.19147 8.93171C4.18915 7.97576 4.46993 7.04052 4.9984 6.24391C5.52687 5.44731 6.27937 4.82501 7.16102 4.45549C8.04118 4.0886 9.01068 3.99226 9.94583 4.17874C10.881 4.36523 11.7394 4.82609 12.4115 5.50252C12.9158 6.00961 13.3018 6.62188 13.542 7.29553C13.7821 7.96919 13.8705 8.68759 13.8006 9.39936C13.7308 10.1111 13.5045 10.7987 13.138 11.4128C12.7715 12.0269 12.2739 12.5525 11.6806 12.9519C10.7549 13.5731 9.6419 13.8527 8.53253 13.743C7.42315 13.6333 6.38653 13.1409 5.60046 12.3505C4.69674 11.4419 4.18906 10.2128 4.18817 8.93126L4.19147 8.93171Z"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3079_6000">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function StudygenieBlackHat({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn(className)}
      {...props}
      width="22"
      height="24"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.553 0.10575C10.834 -0.03525 11.166 -0.03525 11.447 0.10575L21.447 5.10575C21.786 5.27475 22 5.62075 22 5.99975V11.9998C22 12.5518 21.552 12.9998 21 12.9998C20.448 12.9998 20 12.5518 20 11.9998V7.61775L11.447 11.8938C11.166 12.0347 10.834 12.0347 10.553 11.8938L0.552976 6.89375C0.214976 6.72375 0.000976562 6.37775 0.000976562 5.99975C0.000976562 5.62175 0.214976 5.27575 0.552976 5.10575L10.553 0.10575ZM18.763 5.99975L11 9.88175L3.23598 5.99975L11 2.11775L18.763 5.99975Z"
        fill="#0D0D0D"
      />
      <path
        d="M5 7.00195C5.552 7.00195 6 7.44995 6 8.00195V12.567C7.269 13.663 9.1 14.252 11 14.252C12.9 14.252 14.731 13.662 16 12.567V8.00195C16 7.44995 16.448 7.00195 17 7.00195C17.552 7.00195 18 7.44995 18 8.00195V13.002C18 13.267 17.895 13.522 17.707 13.709C15.977 15.439 13.448 16.252 11 16.252C8.552 16.252 6.023 15.439 4.293 13.709C4.105 13.522 4 13.267 4 13.002V8.00195C4 7.44995 4.448 7.00195 5 7.00195Z"
        fill="#0D0D0D"
      />
    </svg>
  );
}

function StudygenieFullLogo({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      width="120"
      height="24"
      viewBox="0 0 120 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.553 4.10575C11.834 3.96475 12.166 3.96475 12.447 4.10575L22.447 9.10575C22.786 9.27475 23 9.62075 23 9.99975V15.9998C23 16.5518 22.552 16.9998 22 16.9998C21.448 16.9998 21 16.5518 21 15.9998V11.6178L12.447 15.8938C12.166 16.0347 11.834 16.0347 11.553 15.8938L1.55298 10.8938C1.21498 10.7238 1.00098 10.3777 1.00098 9.99975C1.00098 9.62175 1.21498 9.27575 1.55298 9.10575L11.553 4.10575ZM19.763 9.99975L12 13.8818L4.23598 9.99975L12 6.11775L19.763 9.99975Z"
        fill="#0D0D0D"
      />
      <path
        d="M6 11.002C6.552 11.002 7 11.45 7 12.002V16.567C8.269 17.663 10.1 18.252 12 18.252C13.9 18.252 15.731 17.662 17 16.567V12.002C17 11.45 17.448 11.002 18 11.002C18.552 11.002 19 11.45 19 12.002V17.002C19 17.267 18.895 17.522 18.707 17.709C16.977 19.439 14.448 20.252 12 20.252C9.552 20.252 7.023 19.439 5.293 17.709C5.105 17.522 5 17.267 5 17.002V12.002C5 11.45 5.448 11.002 6 11.002Z"
        fill="#0D0D0D"
      />
      <path
        d="M35.9489 11.7773L33.8389 12.0073C33.7759 11.7883 33.6699 11.5843 33.5259 11.4073C33.3699 11.2103 33.1679 11.0543 32.9379 10.9523C32.6909 10.8373 32.3879 10.7803 32.0309 10.7803C31.5489 10.7803 31.1439 10.8843 30.8159 11.0933C30.4919 11.3023 30.3319 11.5733 30.3359 11.9053C30.3239 12.1743 30.4409 12.4323 30.6499 12.6023C30.8669 12.7803 31.2249 12.9283 31.7239 13.0423L33.3979 13.4013C34.3279 13.6013 35.0179 13.9183 35.4689 14.3533C35.9249 14.7883 36.1559 15.3573 36.1589 16.0603C36.1639 16.6503 35.9739 17.2263 35.6169 17.6963C35.2629 18.1653 34.7709 18.5313 34.1399 18.7963C33.5099 19.0603 32.7849 19.1923 31.9669 19.1923C30.7649 19.1923 29.7969 18.9403 29.0649 18.4373C28.3319 17.9303 27.8949 17.2253 27.7549 16.3223L30.0109 16.1043C30.1129 16.5483 30.3309 16.8823 30.6629 17.1083C30.9949 17.3343 31.4279 17.4473 31.9599 17.4473C32.5099 17.4473 32.9509 17.3343 33.2829 17.1083C33.6199 16.8823 33.7879 16.6033 33.7879 16.2713C33.7929 16.0013 33.6729 15.7433 33.4619 15.5743C33.2489 15.3913 32.9169 15.2503 32.4649 15.1523L30.7899 14.8003C29.8489 14.6043 29.1519 14.2743 28.6999 13.8103C28.2489 13.3403 28.0249 12.7493 28.0299 12.0333C28.0249 11.4283 28.1889 10.9033 28.5209 10.4603C28.8579 10.0133 29.3249 9.66834 29.9209 9.42534C30.5219 9.17834 31.2149 9.05434 31.9989 9.05434C33.1489 9.05434 34.0549 9.29934 34.7149 9.78934C35.3799 10.2793 35.7909 10.9423 35.9489 11.7773ZM42.4309 9.18234V10.9723H36.7859V9.18234H42.4309ZM38.1799 6.83034H40.4939V16.0473C40.4939 16.3583 40.5409 16.5973 40.6339 16.7633C40.7199 16.9143 40.8559 17.0323 41.0179 17.0953C41.1759 17.1553 41.3499 17.1853 41.5419 17.1853C41.6869 17.1853 41.8189 17.1743 41.9379 17.1533C42.0619 17.1313 42.1559 17.1133 42.2199 17.0953L42.6099 18.9053C42.4859 18.9473 42.3099 18.9943 42.0789 19.0453C41.8059 19.1023 41.5269 19.1323 41.2479 19.1353C40.6679 19.1513 40.1459 19.0643 39.6819 18.8723C39.2309 18.6873 38.8459 18.3713 38.5759 17.9653C38.3079 17.5553 38.1759 17.0443 38.1799 16.4303V6.83034ZM50.0839 14.8703V9.18334H52.3969V19.0003H50.1539V17.2553H50.0519C49.8299 17.8053 49.4659 18.2553 48.9589 18.6043C48.4559 18.9543 47.8359 19.1283 47.0989 19.1283C46.4549 19.1283 45.8859 18.9853 45.3919 18.7003C44.9019 18.4103 44.5179 17.9903 44.2419 17.4403C43.9639 16.8863 43.8259 16.2173 43.8259 15.4333V9.18234H46.1399V15.0753C46.1399 15.6973 46.3099 16.1923 46.6509 16.5583C46.9909 16.9253 47.4389 17.1083 47.9929 17.1083C48.3339 17.1083 48.6639 17.0253 48.9839 16.8583C49.3089 16.6883 49.5799 16.4323 49.7699 16.1183C49.9799 15.7853 50.0829 15.3693 50.0829 14.8713L50.0839 14.8703ZM57.8799 19.1733C57.1459 19.1833 56.4259 18.9763 55.8099 18.5783C55.1999 18.1823 54.7179 17.6073 54.3649 16.8523C54.0109 16.0983 53.8349 15.1823 53.8349 14.1043C53.8349 13.0133 54.0129 12.0923 54.3709 11.3423C54.7329 10.5883 55.2209 10.0193 55.8349 9.63634C56.4489 9.24834 57.1609 9.04634 57.8869 9.05434C58.4619 9.05434 58.9349 9.15234 59.3059 9.34834C59.6759 9.54034 59.9709 9.77234 60.1879 10.0453C60.4049 10.3133 60.5739 10.5673 60.6929 10.8053H60.7889V5.91034H63.1089V19.0003H60.8329V17.4533H60.6929C60.5729 17.6923 60.4009 17.9453 60.1749 18.2133C59.9489 18.4783 59.6509 18.7033 59.2799 18.8913C58.9099 19.0793 58.4429 19.1733 57.8799 19.1733ZM58.5259 17.2743C59.0159 17.2743 59.4339 17.1423 59.7789 16.8783C60.1239 16.6093 60.3859 16.2363 60.5649 15.7593C60.7439 15.2823 60.8339 14.7263 60.8339 14.0913C60.8339 13.4563 60.7439 12.9043 60.5649 12.4353C60.3899 11.9673 60.1299 11.6023 59.7849 11.3423C59.4449 11.0823 59.0249 10.9523 58.5259 10.9523C58.0099 10.9523 57.5799 11.0873 57.2349 11.3553C56.8899 11.6243 56.6299 11.9953 56.4549 12.4673C56.2799 12.9403 56.1929 13.4813 56.1929 14.0913C56.1929 14.7053 56.2799 15.2523 56.4549 15.7343C56.6339 16.2113 56.8959 16.5883 57.2409 16.8653C57.5909 17.1383 58.0189 17.2743 58.5259 17.2743ZM66.4729 22.6823C66.1579 22.6823 65.8659 22.6563 65.5969 22.6053C65.3809 22.5713 65.1699 22.5153 64.9649 22.4393L65.5009 20.6363C65.7929 20.7273 66.0969 20.7753 66.4029 20.7773C66.6669 20.7733 66.8989 20.6903 67.0989 20.5273C67.3039 20.3703 67.4759 20.1063 67.6169 19.7353L67.8149 19.2053L64.2549 9.18234H66.7099L68.9719 16.5973H69.0749L71.3439 9.18234H73.8039L69.8739 20.1893C69.7099 20.6733 69.4629 21.1253 69.1439 21.5253C68.8419 21.9003 68.4719 22.1853 68.0329 22.3813C67.5979 22.5813 67.0779 22.6823 66.4729 22.6823ZM78.8019 22.8863C77.9709 22.8863 77.2569 22.7733 76.6599 22.5483C76.0639 22.3263 75.5839 22.0283 75.2219 21.6533C74.8749 21.3033 74.6169 20.8763 74.4679 20.4063L76.5519 19.9013C76.6449 20.0933 76.7819 20.2833 76.9609 20.4713C77.1399 20.6613 77.3809 20.8203 77.6829 20.9433C77.9899 21.0713 78.3759 21.1353 78.8399 21.1353C79.4959 21.1353 80.0399 20.9753 80.4699 20.6553C80.8999 20.3403 81.1159 19.8203 81.1159 19.0953V17.2353H80.9999C80.8799 17.4753 80.7059 17.7203 80.4749 17.9713C80.2219 18.2423 79.9159 18.4573 79.5749 18.6043C79.2039 18.7743 78.7369 18.8593 78.1749 18.8593C77.4559 18.8683 76.7479 18.6853 76.1229 18.3293C75.5129 17.9713 75.0269 17.4393 74.6649 16.7313C74.3069 16.0193 74.1279 15.1293 74.1279 14.0593C74.1279 12.9813 74.3079 12.0713 74.6649 11.3293C75.0269 10.5843 75.5149 10.0193 76.1289 9.63634C76.7429 9.24834 77.4549 9.04634 78.1809 9.05434C78.7559 9.05434 79.2289 9.15234 79.5999 9.34834C79.9749 9.54034 80.2729 9.77234 80.4949 10.0453C80.7159 10.3133 80.8849 10.5673 80.9999 10.8053H81.1269V9.18234H83.4089V19.1603C83.4089 20.0003 83.2089 20.6943 82.8089 21.2443C82.4079 21.7943 81.8599 22.2043 81.1659 22.4773C80.4709 22.7503 79.6829 22.8873 78.8009 22.8873L78.8019 22.8863ZM78.8209 17.0443C79.3109 17.0443 79.7289 16.9243 80.0739 16.6863C80.4189 16.4473 80.6809 16.1043 80.8599 15.6573C81.0389 15.2103 81.1289 14.6733 81.1289 14.0473C81.1289 13.4283 81.0389 12.8873 80.8599 12.4233C80.6849 11.9583 80.4249 11.5983 80.0799 11.3433C79.7399 11.0833 79.3199 10.9533 78.8209 10.9533C78.3049 10.9533 77.8749 11.0873 77.5299 11.3553C77.1849 11.6243 76.9249 11.9923 76.7499 12.4613C76.5749 12.9253 76.4879 13.4543 76.4879 14.0463C76.4879 14.6473 76.5749 15.1733 76.7499 15.6253C76.9289 16.0723 77.1909 16.4223 77.5359 16.6733C77.8859 16.9213 78.3139 17.0443 78.8209 17.0443ZM89.5879 19.1923C88.6039 19.1923 87.7539 18.9873 87.0379 18.5783C86.3299 18.1693 85.7579 17.5603 85.3949 16.8273C85.0119 16.0683 84.8199 15.1753 84.8199 14.1483C84.8199 13.1383 85.0119 12.2523 85.3949 11.4893C85.7569 10.7513 86.3199 10.1313 87.0199 9.70034C87.7139 9.27034 88.5299 9.05534 89.4679 9.05534C90.0729 9.05534 90.6439 9.15334 91.1809 9.34934C91.7219 9.54134 92.1999 9.83934 92.6129 10.2443C93.0309 10.6493 93.3589 11.1643 93.5969 11.7913C93.8359 12.4133 93.9549 13.1543 93.9549 14.0153V14.7253H85.9079V13.1653H91.7379C91.7409 12.7533 91.6419 12.3473 91.4499 11.9833C91.2689 11.6403 90.9969 11.3553 90.6629 11.1583C90.3309 10.9583 89.9429 10.8583 89.4999 10.8583C89.0269 10.8583 88.6119 10.9733 88.2539 11.2033C87.9009 11.4233 87.6119 11.7323 87.4159 12.0983C87.2189 12.4703 87.1159 12.8853 87.1159 13.3063V14.6673C87.1159 15.2383 87.2199 15.7283 87.4289 16.1373C87.6379 16.5423 87.9289 16.8533 88.3049 17.0713C88.6799 17.2843 89.1189 17.3913 89.6209 17.3913C89.9309 17.3953 90.2399 17.3473 90.5349 17.2503C90.7989 17.1583 91.0409 17.0123 91.2449 16.8213C91.4449 16.6343 91.5969 16.4013 91.6989 16.1253L93.8589 16.3673C93.7299 16.9243 93.4619 17.4393 93.0789 17.8633C92.6999 18.2853 92.2139 18.6133 91.6219 18.8483C91.0299 19.0783 90.3519 19.1933 89.5899 19.1933L89.5879 19.1923ZM97.6859 13.2473V19.0003H95.3719V9.18234H97.5839V10.8503H97.6979C97.9239 10.3003 98.2849 9.86434 98.7779 9.54034C99.2779 9.21634 99.8929 9.05434 100.626 9.05434C101.304 9.05434 101.894 9.19934 102.397 9.48934C102.904 9.77934 103.296 10.1993 103.573 10.7483C103.854 11.2983 103.993 11.9643 103.988 12.7483V19.0003H101.674V13.1073C101.674 12.4503 101.504 11.9373 101.163 11.5673C100.826 11.1953 100.36 11.0103 99.7629 11.0103C99.3579 11.0103 98.9979 11.1003 98.6829 11.2783C98.3699 11.4553 98.1139 11.7203 97.9479 12.0393C97.7729 12.3713 97.6859 12.7743 97.6859 13.2473ZM105.8 19.0003V9.18234H108.113V19.0003H105.8ZM106.963 7.78834C106.596 7.78834 106.281 7.66734 106.017 7.42434C105.763 7.19934 105.619 6.87534 105.621 6.53634C105.621 6.18634 105.753 5.89034 106.017 5.64734C106.281 5.40034 106.596 5.27734 106.963 5.27734C107.334 5.27734 107.649 5.40034 107.909 5.64734C108.173 5.89034 108.305 6.18734 108.305 6.53634C108.305 6.88134 108.173 7.17634 107.909 7.42434C107.649 7.66734 107.334 7.78834 106.963 7.78834ZM114.3 19.1923C113.315 19.1923 112.465 18.9873 111.749 18.5783C111.041 18.1693 110.47 17.5603 110.106 16.8273C109.723 16.0683 109.531 15.1753 109.531 14.1483C109.531 13.1383 109.723 12.2523 110.106 11.4893C110.467 10.7513 111.03 10.1303 111.73 9.69934C112.425 9.26934 113.241 9.05434 114.178 9.05434C114.783 9.05434 115.354 9.15234 115.891 9.34834C116.432 9.54034 116.91 9.83834 117.323 10.2433C117.741 10.6483 118.069 11.1633 118.307 11.7903C118.546 12.4123 118.665 13.1533 118.665 14.0143V14.7243H110.618V13.1643H116.447C116.45 12.7523 116.352 12.3463 116.16 11.9823C115.979 11.6393 115.707 11.3543 115.373 11.1573C115.041 10.9573 114.653 10.8573 114.21 10.8573C113.737 10.8573 113.322 10.9723 112.964 11.2023C112.611 11.4223 112.322 11.7313 112.126 12.0973C111.929 12.4693 111.826 12.8843 111.826 13.3053V14.6663C111.826 15.2373 111.93 15.7273 112.139 16.1363C112.348 16.5413 112.64 16.8523 113.015 17.0703C113.39 17.2833 113.829 17.3903 114.331 17.3903C114.668 17.3903 114.973 17.3423 115.246 17.2493C115.509 17.1563 115.751 17.0103 115.955 16.8203C116.155 16.6333 116.307 16.4003 116.409 16.1243L118.569 16.3663C118.44 16.9233 118.172 17.4373 117.79 17.8623C117.41 18.2843 116.925 18.6123 116.332 18.8473C115.74 19.0773 115.062 19.1923 114.3 19.1923Z"
        fill="#0D0D0D"
      />
    </svg>
  );
}

function IconYoutube({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      className={cn("size-4", className)}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M508.64,148.79c0-45-33.1-81.2-74-81.2C379.24,65,322.74,64,265,64H247c-57.6,0-114.2,1-169.6,3.6-40.8,0-73.9,36.4-73.9,81.4C1,184.59-.06,220.19,0,255.79q-.15,53.4,3.4,106.9c0,45,33.1,81.5,73.9,81.5,58.2,2.7,117.9,3.9,178.6,3.8q91.2.3,178.6-3.8c40.9,0,74-36.5,74-81.5,2.4-35.7,3.5-71.3,3.4-107Q512.24,202.29,508.64,148.79ZM207,353.89V157.39l145,98.2Z"
        fill="#FF0000"
      />
      <path d="M207,353.89V157.39l145,98.2Z" fill="#FFFFFF" />
    </svg>
  );
}

// function StudygenieBlackHat({
//   className,
//   ...props
// }: React.ComponentProps<"svg"> & { inverted?: boolean }) {
//   return (
//     <svg
//       className={cn("size-4", className)}
//       {...props}
//       viewBox="0 0 28 22"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M13.4304 0.801589C13.7881 0.622127 14.2106 0.622127 14.5683 0.801589L27.2962 7.16551C27.7276 7.38061 28 7.821 28 8.30338V15.9401C28 16.6427 27.4298 17.2129 26.7272 17.2129C26.0246 17.2129 25.4544 16.6427 25.4544 15.9401V10.3627L14.5683 15.8052C14.2106 15.9846 13.7881 15.9846 13.4304 15.8052L0.702577 9.44125C0.272376 9.22488 0 8.7845 0 8.30338C0 7.82227 0.272376 7.38189 0.702577 7.16551L13.4304 0.801589ZM23.88 8.30338L13.9994 13.2443L4.11746 8.30338L13.9994 3.36243L23.88 8.30338Z"
//         fill="#0D0D0D"
//       />
//       <path
//         d="M6.36214 9.57031C7.06472 9.57031 7.63493 10.1405 7.63493 10.8431V16.6534C9.25009 18.0483 11.5806 18.798 13.9989 18.798C16.4171 18.798 18.7476 18.0471 20.3628 16.6534V10.8431C20.3628 10.1405 20.933 9.57031 21.6356 9.57031C22.3381 9.57031 22.9083 10.1405 22.9083 10.8431V17.207C22.9083 17.5443 22.7747 17.8689 22.5354 18.1069C20.3335 20.3088 17.1146 21.3436 13.9989 21.3436C10.8831 21.3436 7.6642 20.3088 5.46228 18.1069C5.223 17.8689 5.08936 17.5443 5.08936 17.207V10.8431C5.08936 10.1405 5.65956 9.57031 6.36214 9.57031Z"
//         fill="#0D0D0D"
//       />
//     </svg>
//   );
// }

function IconProgressCircle({
  className,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#5f6368"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M441-82Q287-97 184-211T81-480q0-155 103-269t257-129v120q-104 14-172 93t-68 185q0 106 68 185t172 93v120Zm80 0v-120q94-12 159-78t79-160h120q-14 143-114.5 243.5T521-82Zm238-438q-14-94-79-160t-159-78v-120q143 14 243.5 114.5T879-520H759Z" />
    </svg>
  );
}

function IconNextChat({
  className,
  inverted,
  ...props
}: React.ComponentProps<"svg"> & { inverted?: boolean }) {
  const id = React.useId();

  return (
    <svg
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-4", className)}
      {...props}
    >
      <defs>
        <linearGradient
          id={`gradient-${id}-1`}
          x1="10.6889"
          y1="10.3556"
          x2="13.8445"
          y2="14.2667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={inverted ? "white" : "black"} />
          <stop
            offset={1}
            stopColor={inverted ? "white" : "black"}
            stopOpacity={0}
          />
        </linearGradient>
        <linearGradient
          id={`gradient-${id}-2`}
          x1="11.7555"
          y1="4.8"
          x2="11.7376"
          y2="9.50002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={inverted ? "white" : "black"} />
          <stop
            offset={1}
            stopColor={inverted ? "white" : "black"}
            stopOpacity={0}
          />
        </linearGradient>
      </defs>
      <path
        d="M1 16L2.58314 11.2506C1.83084 9.74642 1.63835 8.02363 2.04013 6.39052C2.4419 4.75741 3.41171 3.32057 4.776 2.33712C6.1403 1.35367 7.81003 0.887808 9.4864 1.02289C11.1628 1.15798 12.7364 1.8852 13.9256 3.07442C15.1148 4.26363 15.842 5.83723 15.9771 7.5136C16.1122 9.18997 15.6463 10.8597 14.6629 12.224C13.6794 13.5883 12.2426 14.5581 10.6095 14.9599C8.97637 15.3616 7.25358 15.1692 5.74942 14.4169L1 16Z"
        fill={inverted ? "black" : "white"}
        stroke={inverted ? "black" : "white"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_91_2047"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={0}
        width={16}
        height={16}
      >
        <circle cx={9} cy={8} r={8} fill={inverted ? "black" : "white"} />
      </mask>
      <g mask="url(#mask0_91_2047)">
        <circle cx={9} cy={8} r={8} fill={inverted ? "black" : "white"} />
        <path
          d="M14.2896 14.0018L7.146 4.8H5.80005V11.1973H6.87681V6.16743L13.4444 14.6529C13.7407 14.4545 14.0231 14.2369 14.2896 14.0018Z"
          fill={`url(#gradient-${id}-1)`}
        />
        <rect
          x="11.2222"
          y="4.8"
          width="1.06667"
          height="6.4"
          fill={`url(#gradient-${id}-2)`}
        />
      </g>
    </svg>
  );
}

function IconOpenAI({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-4", className)}
      {...props}
    >
      <title>OpenAI icon</title>
      <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
    </svg>
  );
}

function IconVercel({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-label="Vercel logomark"
      role="img"
      viewBox="0 0 74 64"
      className={cn("size-4", className)}
      {...props}
    >
      <path
        d="M37.5896 0.25L74.5396 64.25H0.639648L37.5896 0.25Z"
        fill="currentColor"
      />
    </svg>
  );
}

function IconGitHub({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <title>GitHub</title>
      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
    </svg>
  );
}

function IconSeparator({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      fill="none"
      shapeRendering="geometricPrecision"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M16.88 3.549L7.12 20.451" />
    </svg>
  );
}

function IconArrowDown({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="m205.66 149.66-72 72a8 8 0 0 1-11.32 0l-72-72a8 8 0 0 1 11.32-11.32L120 196.69V40a8 8 0 0 1 16 0v156.69l58.34-58.35a8 8 0 0 1 11.32 11.32Z" />
    </svg>
  );
}

function IconArrowRight({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="m221.66 133.66-72 72a8 8 0 0 1-11.32-11.32L196.69 136H40a8 8 0 0 1 0-16h156.69l-58.35-58.34a8 8 0 0 1 11.32-11.32l72 72a8 8 0 0 1 0 11.32Z" />
    </svg>
  );
}

function IconUser({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z" />
    </svg>
  );
}

function IconPlus({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M224 128a8 8 0 0 1-8 8h-80v80a8 8 0 0 1-16 0v-80H40a8 8 0 0 1 0-16h80V40a8 8 0 0 1 16 0v80h80a8 8 0 0 1 8 8Z" />
    </svg>
  );
}

function IconArrowElbow({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M200 32v144a8 8 0 0 1-8 8H67.31l34.35 34.34a8 8 0 0 1-11.32 11.32l-48-48a8 8 0 0 1 0-11.32l48-48a8 8 0 0 1 11.32 11.32L67.31 168H184V32a8 8 0 0 1 16 0Z" />
    </svg>
  );
}

function IconSpinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4 animate-spin", className)}
      {...props}
    >
      <path d="M232 128a104 104 0 0 1-208 0c0-41 23.81-78.36 60.66-95.27a8 8 0 0 1 6.68 14.54C60.15 61.59 40 93.27 40 128a88 88 0 0 0 176 0c0-34.73-20.15-66.41-51.34-80.73a8 8 0 0 1 6.68-14.54C208.19 49.64 232 87 232 128Z" />
    </svg>
  );
}

function IconMessage({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M216 48H40a16 16 0 0 0-16 16v160a15.84 15.84 0 0 0 9.25 14.5A16.05 16.05 0 0 0 40 240a15.89 15.89 0 0 0 10.25-3.78.69.69 0 0 0 .13-.11L82.5 208H216a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16ZM40 224Zm176-32H82.5a16 16 0 0 0-10.3 3.75l-.12.11L40 224V64h176Z" />
    </svg>
  );
}

function IconTrash({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16ZM96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Zm48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Z" />
    </svg>
  );
}

function IconRefresh({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M197.67 186.37a8 8 0 0 1 0 11.29C196.58 198.73 170.82 224 128 224c-37.39 0-64.53-22.4-80-39.85V208a8 8 0 0 1-16 0v-48a8 8 0 0 1 8-8h48a8 8 0 0 1 0 16H55.44C67.76 183.35 93 208 128 208c36 0 58.14-21.46 58.36-21.68a8 8 0 0 1 11.31.05ZM216 40a8 8 0 0 0-8 8v23.85C192.53 54.4 165.39 32 128 32c-42.82 0-68.58 25.27-69.66 26.34a8 8 0 0 0 11.3 11.34C69.86 69.46 92 48 128 48c35 0 60.24 24.65 72.56 40H168a8 8 0 0 0 0 16h48a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8Z" />
    </svg>
  );
}

function IconStop({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88Zm24-120h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8Zm-8 48h-32v-32h32Z" />
    </svg>
  );
}

function IconSidebar({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16ZM40 56h40v144H40Zm176 144H96V56h120v144Z" />
    </svg>
  );
}

function IconMoon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M233.54 142.23a8 8 0 0 0-8-2 88.08 88.08 0 0 1-109.8-109.8 8 8 0 0 0-10-10 104.84 104.84 0 0 0-52.91 37A104 104 0 0 0 136 224a103.09 103.09 0 0 0 62.52-20.88 104.84 104.84 0 0 0 37-52.91 8 8 0 0 0-1.98-7.98Zm-44.64 48.11A88 88 0 0 1 65.66 67.11a89 89 0 0 1 31.4-26A106 106 0 0 0 96 56a104.11 104.11 0 0 0 104 104 106 106 0 0 0 14.92-1.06 89 89 0 0 1-26.02 31.4Z" />
    </svg>
  );
}

function IconSun({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M120 40V16a8 8 0 0 1 16 0v24a8 8 0 0 1-16 0Zm72 88a64 64 0 1 1-64-64 64.07 64.07 0 0 1 64 64Zm-16 0a48 48 0 1 0-48 48 48.05 48.05 0 0 0 48-48ZM58.34 69.66a8 8 0 0 0 11.32-11.32l-16-16a8 8 0 0 0-11.32 11.32Zm0 116.68-16 16a8 8 0 0 0 11.32 11.32l16-16a8 8 0 0 0-11.32-11.32ZM192 72a8 8 0 0 0 5.66-2.34l16-16a8 8 0 0 0-11.32-11.32l-16 16A8 8 0 0 0 192 72Zm5.66 114.34a8 8 0 0 0-11.32 11.32l16 16a8 8 0 0 0 11.32-11.32ZM48 128a8 8 0 0 0-8-8H16a8 8 0 0 0 0 16h24a8 8 0 0 0 8-8Zm80 80a8 8 0 0 0-8 8v24a8 8 0 0 0 16 0v-24a8 8 0 0 0-8-8Zm112-88h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16Z" />
    </svg>
  );
}

function IconCopy({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M216 32H88a8 8 0 0 0-8 8v40H40a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8Zm-56 176H48V96h112Zm48-48h-32V88a8 8 0 0 0-8-8H96V48h112Z" />
    </svg>
  );
}

function IconCheck({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="m229.66 77.66-128 128a8 8 0 0 1-11.32 0l-56-56a8 8 0 0 1 11.32-11.32L96 188.69 218.34 66.34a8 8 0 0 1 11.32 11.32Z" />
    </svg>
  );
}

function IconDownload({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M224 152v56a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-56a8 8 0 0 1 16 0v56h160v-56a8 8 0 0 1 16 0Zm-101.66 5.66a8 8 0 0 0 11.32 0l40-40a8 8 0 0 0-11.32-11.32L136 132.69V40a8 8 0 0 0-16 0v92.69l-26.34-26.35a8 8 0 0 0-11.32 11.32Z" />
    </svg>
  );
}

function IconClose({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path d="M205.66 194.34a8 8 0 0 1-11.32 11.32L128 139.31l-66.34 66.35a8 8 0 0 1-11.32-11.32L116.69 128 50.34 61.66a8 8 0 0 1 11.32-11.32L128 116.69l66.34-66.35a8 8 0 0 1 11.32 11.32L139.31 128Z" />
    </svg>
  );
}

function IconEdit({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={cn("size-4", className)}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
      />
    </svg>
  );
}

function IconShare({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("size-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="m237.66 106.35-80-80A8 8 0 0 0 144 32v40.35c-25.94 2.22-54.59 14.92-78.16 34.91-28.38 24.08-46.05 55.11-49.76 87.37a12 12 0 0 0 20.68 9.58c11-11.71 50.14-48.74 107.24-52V192a8 8 0 0 0 13.66 5.65l80-80a8 8 0 0 0 0-11.3ZM160 172.69V144a8 8 0 0 0-8-8c-28.08 0-55.43 7.33-81.29 21.8a196.17 196.17 0 0 0-36.57 26.52c5.8-23.84 20.42-46.51 42.05-64.86C99.41 99.77 127.75 88 152 88a8 8 0 0 0 8-8V51.32L220.69 112Z" />
    </svg>
  );
}

function IconUsers({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("size-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M117.25 157.92a60 60 0 1 0-66.5 0 95.83 95.83 0 0 0-47.22 37.71 8 8 0 1 0 13.4 8.74 80 80 0 0 1 134.14 0 8 8 0 0 0 13.4-8.74 95.83 95.83 0 0 0-47.22-37.71ZM40 108a44 44 0 1 1 44 44 44.05 44.05 0 0 1-44-44Zm210.14 98.7a8 8 0 0 1-11.07-2.33A79.83 79.83 0 0 0 172 168a8 8 0 0 1 0-16 44 44 0 1 0-16.34-84.87 8 8 0 1 1-5.94-14.85 60 60 0 0 1 55.53 105.64 95.83 95.83 0 0 1 47.22 37.71 8 8 0 0 1-2.33 11.07Z" />
    </svg>
  );
}

function IconExternalLink({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("size-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M224 104a8 8 0 0 1-16 0V59.32l-66.33 66.34a8 8 0 0 1-11.32-11.32L196.68 48H152a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8Zm-40 24a8 8 0 0 0-8 8v72H48V80h72a8 8 0 0 0 0-16H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-72a8 8 0 0 0-8-8Z" />
    </svg>
  );
}

function IconChevronUpDown({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={cn("size-4", className)}
      viewBox="0 0 256 256"
      {...props}
    >
      <path d="M181.66 170.34a8 8 0 0 1 0 11.32l-48 48a8 8 0 0 1-11.32 0l-48-48a8 8 0 0 1 11.32-11.32L128 212.69l42.34-42.35a8 8 0 0 1 11.32 0Zm-96-84.68L128 43.31l42.34 42.35a8 8 0 0 0 11.32-11.32l-48-48a8 8 0 0 0-11.32 0l-48 48a8 8 0 0 0 11.32 11.32Z" />
    </svg>
  );
}

function IconStudygenieChat({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 54 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-4", className)}
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g filter="url(#filter0_ddii_5382_7210)">
        <g clipPath="url(#clip0_5382_7210)">
          <path
            d="M12 30C12 23.3726 17.3726 18 24 18C30.6274 18 36 23.3726 36 30C36 36.6274 30.6274 42 24 42C17.3726 42 12 36.6274 12 30Z"
            fill="white"
          />
          <g filter="url(#filter1_f_5382_7210)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.2569 37.7823C13.6868 36.9901 13.0291 36.1679 12.9687 35.1937C12.9075 34.2069 13.1442 33.0319 13.9249 32.4253C14.7726 31.7667 16.4172 32.8488 17.0767 32.0018C18.1432 30.6321 16.4392 27.1383 18.1676 26.9763C19.9642 26.8078 19.3086 30.57 20.7485 31.6575C21.5398 32.2551 22.6419 31.1141 23.6335 31.1043C25.5788 31.085 29.3663 29.6266 29.3777 31.5721C29.3919 33.9774 23.9198 33.4348 23.6613 35.8263C23.4197 38.0609 28.0262 38.2758 28.4137 40.4897C28.6684 41.9456 26.2976 42.566 24.9449 43.1617C23.7024 43.7089 22.3065 44.001 20.9689 43.7683C19.7363 43.554 18.7048 42.7334 17.7609 41.9122C17.0138 41.2622 16.716 40.2662 16.0753 39.5111C15.5273 38.8652 14.7516 38.4698 14.2569 37.7823Z"
              fill="#0077FF"
            />
          </g>
          <g filter="url(#filter2_f_5382_7210)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.7841 16.6592C20.739 16.4316 21.7553 16.1338 22.6847 16.4499C23.6262 16.77 24.629 17.4391 24.895 18.3973C25.1839 19.4377 23.5486 20.5543 24.0847 21.4916C24.9515 23.0072 28.8532 22.7568 28.3435 24.4268C27.8137 26.1627 24.564 24.1151 23.0019 25.0393C22.1436 25.5472 22.784 27.0085 22.4142 27.9348C21.6888 29.7521 21.5985 33.8332 19.7841 33.1004C17.5407 32.1945 20.1365 27.3107 18.0103 26.1563C16.0236 25.0777 14.0635 29.2814 11.8556 28.7959C10.4037 28.4766 10.7325 26.0338 10.6951 24.5476C10.6608 23.1825 10.9224 21.7722 11.65 20.6166C12.3204 19.5517 13.4781 18.9056 14.6027 18.3412C15.493 17.8944 16.5334 17.998 17.4808 17.6904C18.2911 17.4274 18.9554 16.8568 19.7841 16.6592Z"
              fill="#0077FF"
            />
          </g>
          <g filter="url(#filter3_f_5382_7210)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.033 16.1448C28.9241 16.1469 29.8329 16.0572 30.6619 16.3841C31.5129 16.7196 32.741 17.1181 32.8146 18.0299C32.9121 19.238 31.2346 19.9577 31.047 21.1552C30.9473 21.7918 31.9047 22.143 32.0728 22.7651C32.278 23.5247 32.2604 24.3231 32.1117 25.0957C31.9083 26.1522 32.0931 27.8528 31.0459 28.0994C29.8497 28.381 29.2461 26.2519 28.033 26.0561C27.0934 25.9045 26.406 27.2254 25.4547 27.197C24.5008 27.1685 23.6452 26.5478 22.9407 25.904C22.1889 25.217 20.8153 24.2891 21.2821 23.3839C21.9943 22.0029 24.789 22.6797 25.3507 21.2309C25.8058 20.0572 23.3206 19.3536 23.3328 18.0948C23.3416 17.1868 24.5592 16.7192 25.3979 16.3712C26.2225 16.0291 27.1402 16.1426 28.033 16.1448Z"
              fill="#2DABFF"
            />
          </g>
          <g filter="url(#filter4_f_5382_7210)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.10667 26.4675C7.99952 25.5828 7.79901 24.6919 8.02168 23.829C8.25025 22.9433 8.49518 21.6756 9.39102 21.4907C10.578 21.2458 11.4981 22.8223 12.7095 22.8616C13.3536 22.8825 13.5847 21.8892 14.1815 21.6461C14.9102 21.3492 15.7047 21.2687 16.4897 21.3216C17.5632 21.3939 19.2282 21.0018 19.6014 22.0109C20.0277 23.1635 17.9887 24.0237 17.9432 25.2517C17.9079 26.2028 19.3032 26.7229 19.3917 27.6706C19.4804 28.6207 18.9693 29.546 18.4169 30.3241C17.8273 31.1545 17.0748 32.6316 16.1193 32.2794C14.6613 31.7419 14.9901 28.8854 13.4834 28.5056C12.2627 28.1979 11.8693 30.7507 10.6185 30.893C9.71635 30.9956 9.10286 29.8446 8.65465 29.0549C8.21395 28.2784 8.21402 27.3538 8.10667 26.4675Z"
              fill="#2DABFF"
            />
          </g>
          <g filter="url(#filter5_f_5382_7210)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M31.2061 45.3566C30.0616 45.5014 29.8935 47.8687 28.7481 47.731C27.6902 47.6038 28.1939 45.5615 27.3628 44.8947C26.5049 44.2063 24.9691 44.8789 24.206 44.0866C23.5064 43.3601 23.264 42.0231 23.742 41.135C24.2913 40.1144 26.01 40.3392 26.7172 39.4208C27.2453 38.735 26.7351 37.6913 27.0225 36.8747C27.4479 35.6663 27.6579 34.1096 28.7946 33.5186C29.8266 32.9821 31.0971 33.7545 32.1728 34.197C33.1688 34.6067 34.2441 35.0764 34.8096 35.9929C35.3657 36.8941 34.6217 38.2194 35.2017 39.1053C35.9384 40.2304 38.8625 40.2154 38.4015 41.4787C37.8367 43.0265 34.6918 41.6574 33.7718 43.0242C33.0062 44.1615 35.7139 46.0561 34.6994 46.9783C33.7374 47.8528 32.4959 45.1935 31.2061 45.3566Z"
              fill="#2DABFF"
            />
          </g>
          <g filter="url(#filter6_f_5382_7210)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.5001 34.7875C35.6927 35.4804 34.9408 36.2703 33.9363 36.6213C32.9052 36.9816 31.4838 37.5789 30.7062 36.8118C29.6759 35.7955 30.6315 33.8364 29.8673 32.6073C29.461 31.9539 28.3213 32.3829 27.6841 31.9515C26.9062 31.4247 26.2995 30.689 25.8314 29.8744C25.1914 28.7605 23.6981 27.3668 24.4528 26.3271C25.3147 25.1396 27.5209 26.5942 28.7706 25.8251C29.7385 25.2295 29.3299 23.499 30.2123 22.7827C31.0971 22.0646 32.3549 21.9586 33.4939 21.9914C34.7095 22.0263 36.6753 21.7942 36.9591 22.9767C37.3921 24.7809 34.3372 26.3484 34.9591 28.0966C35.4629 29.5128 38.2589 28.2108 39.2295 29.3586C39.9296 30.1865 39.1933 31.559 38.7063 32.5277C38.2274 33.4802 37.3091 34.0932 36.5001 34.7875Z"
              fill="#0077FF"
            />
          </g>
          <path
            d="M23.7559 25.7159C23.9092 25.639 24.0903 25.639 24.2436 25.7159L29.6983 28.4433C29.8833 28.5355 30 28.7242 30 28.9309V32.2038C30 32.5049 29.7556 32.7493 29.4545 32.7493C29.1534 32.7493 28.909 32.5049 28.909 32.2038V29.8135L24.2436 32.146C24.0903 32.2229 23.9092 32.2229 23.7559 32.146L18.3011 29.4186C18.1167 29.3259 18 29.1371 18 28.9309C18 28.7248 18.1167 28.536 18.3011 28.4433L23.7559 25.7159ZM28.2343 28.9309L23.9997 31.0485L19.7646 28.9309L23.9997 26.8134L28.2343 28.9309Z"
            fill="white"
          />
          <path
            d="M20.7266 29.4738C21.0277 29.4738 21.2721 29.7182 21.2721 30.0193V32.5094C21.9643 33.1073 22.9631 33.4286 23.9995 33.4286C25.0359 33.4286 26.0347 33.1067 26.7269 32.5094V30.0193C26.7269 29.7182 26.9713 29.4738 27.2724 29.4738C27.5735 29.4738 27.8179 29.7182 27.8179 30.0193V32.7467C27.8179 32.8913 27.7606 33.0304 27.658 33.1324C26.7144 34.076 25.3348 34.5195 23.9995 34.5195C22.6642 34.5195 21.2847 34.076 20.341 33.1324C20.2384 33.0304 20.1812 32.8913 20.1812 32.7467V30.0193C20.1812 29.7182 20.4255 29.4738 20.7266 29.4738Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ddii_5382_7210"
          x="-5.25"
          y="0.75"
          width="58.5"
          height="58.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.5"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_5382_7210"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.33 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5382_7210"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.75"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_5382_7210"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.66 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_5382_7210"
            result="effect2_dropShadow_5382_7210"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_5382_7210"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect3_innerShadow_5382_7210"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_5382_7210"
            result="effect4_innerShadow_5382_7210"
          />
        </filter>
        <filter
          id="filter1_f_5382_7210"
          x="8.79399"
          y="22.8052"
          width="24.7494"
          height="25.2099"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.08274"
            result="effect1_foregroundBlur_5382_7210"
          />
        </filter>
        <filter
          id="filter2_f_5382_7210"
          x="5.15571"
          y="10.7807"
          width="28.7652"
          height="27.9386"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.76589"
            result="effect1_foregroundBlur_5382_7210"
          />
        </filter>
        <filter
          id="filter3_f_5382_7210"
          x="17.4375"
          y="12.375"
          width="19.1313"
          height="19.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.875"
            result="effect1_foregroundBlur_5382_7210"
          />
        </filter>
        <filter
          id="filter4_f_5382_7210"
          x="4.1709"
          y="17.5547"
          width="19.2393"
          height="18.5273"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.875"
            result="effect1_foregroundBlur_5382_7210"
          />
        </filter>
        <filter
          id="filter5_f_5382_7210"
          x="18.831"
          y="28.6732"
          width="24.2824"
          height="23.7258"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.33135"
            result="effect1_foregroundBlur_5382_7210"
          />
        </filter>
        <filter
          id="filter6_f_5382_7210"
          x="19.7668"
          y="17.5085"
          width="24.2286"
          height="24.153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.23892"
            result="effect1_foregroundBlur_5382_7210"
          />
        </filter>
        <clipPath id="clip0_5382_7210">
          <path
            d="M12 30C12 23.3726 17.3726 18 24 18C30.6274 18 36 23.3726 36 30C36 36.6274 30.6274 42 24 42C17.3726 42 12 36.6274 12 30Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export {
  AnkiIcon,
  BlackGoogleIcon,
  ChatGPTIcon,
  FileUploadImage,
  IconArrowDown,
  IconArrowElbow,
  IconArrowRight,
  IconCheck,
  IconChevronUpDown,
  IconClose,
  IconCopy,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconGitHub,
  IconGoogle,
  IconMessage,
  IconMoon,
  IconNextChat,
  IconOpenAI,
  IconPlus,
  IconProgressCircle,
  IconQuizlet,
  IconRefresh,
  IconSeparator,
  IconShare,
  IconSidebar,
  IconSpinner,
  IconStop,
  IconStudygenieChat,
  IconSun,
  IconTrash,
  IconUser,
  IconUsers,
  IconVercel,
  IconYoutube,
  RedditIcon,
  StudygenieBlackHat,
  StudygenieFullLogo,
  TikTokIcon,
};
